import React from "react";
import {Result, Button} from "antd";
import {ClockCircleOutlined} from "@ant-design/icons";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {colors} from "../../theme/antdTheme";

const Tips = () => {
    const {t} = useTranslation();

    return (
        <div className="content_container" style={styles.container}>
            <Result
                icon={<ClockCircleOutlined style={styles.icon}/>}
                title={t("common.soonMsg.title")}
                subTitle={t("common.soonMsg.subtitle")}
                extra={[
                    <Link to={"/analysis"}>
                        <Button type="primary">
                            {t("common.soonMsg.button")}
                        </Button>
                    </Link>
                ]}
            />
        </div>
    );
};

const styles = {
    container: {
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "linear-gradient(135deg, #f0f5ff, #d6e4ff)",
        padding: "20px",
    },
    icon: {
        fontSize: "64px",
        color: colors.primary,
    },
};

export default Tips;
